
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MoreIcon, TrendUpIcon, PlusIcon } from '../icons';
import { mockDrafts, mockRecentPosts } from '../../data/mockData';
import { useView } from '../../contexts/ViewContext';


const Card: React.FC<{ title: string; children: React.ReactNode; headerAction?: React.ReactNode; className?: string; }> = ({ title, children, headerAction, className }) => (
    <div className={`bg-white border border-gray-200 rounded-xl shadow-sm ${className}`}>
        <div className="flex justify-between items-center p-4 sm:p-5 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
            {headerAction}
        </div>
        <div className="p-4 sm:p-5">
            {children}
        </div>
    </div>
);

const Dashboard: React.FC = () => {
  const { setView } = useView();
  const navigate = useNavigate();

  const handleCreatePost = () => {
    setView({ page: 'Press Release', subPage: 'new' });
    navigate('/admin/content');
  };
  return (
    <div className="space-y-6">
        <Card 
            title="Draft"
        >
            <div className="space-y-4">
                {mockDrafts.map((draft, index) => (
                    <div key={draft.id} className={`flex justify-between items-center ${index < mockDrafts.length - 1 ? 'pb-4 border-b border-gray-100' : ''}`}>
                        <div>
                            <h3 className="font-semibold text-gray-800">{draft.title}</h3>
                            <p className="text-sm text-gray-500 mt-1">{draft.date} | {draft.author}</p>
                        </div>
                        <button className="text-gray-500 hover:text-gray-800">
                            <MoreIcon className="w-5 h-5" />
                        </button>
                    </div>
                ))}
            </div>
        </Card>
        
        <Card 
            title="Recent Posts"
            headerAction={
                <a href="#" className="text-sm font-semibold text-[#681628] hover:underline">
                    View all
                </a>
            }
        >
            <div className="space-y-4">
                {mockRecentPosts.length > 0 ? mockRecentPosts.map((post, index) => (
                    <div key={post.id} className={`flex items-center gap-4 ${index < mockRecentPosts.length - 1 ? 'pb-4 border-b border-gray-100' : ''}`}>
                        <img src={post.image} alt={post.title} className="w-16 h-12 object-cover rounded-md flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                            <h3 className="font-semibold text-gray-800 text-sm truncate">{post.title}</h3>
                            <p className="text-xs text-gray-500 mt-1">{post.date} | {post.author}</p>
                        </div>
                        <div className="hidden md:block text-center px-4">
                             <p className="text-xs text-gray-500">Total View</p>
                             <p className="text-sm font-semibold text-gray-800">{post.views}</p>
                        </div>
                         <div className="hidden md:block text-center px-4">
                             <p className="text-xs text-gray-500">Total Comment</p>
                             <p className="text-sm font-semibold text-gray-800">{post.comments}</p>
                        </div>
                        <button className="text-gray-500 hover:text-gray-800">
                            <MoreIcon className="w-5 h-5" />
                        </button>
                    </div>
                )) : (
                    <div className="text-center py-10">
                        <div className="inline-block bg-gray-200/20 p-4 rounded-full">
                           <ContentIcon className="w-8 h-8 text-gray-400" />
                        </div>
                        <h3 className="mt-4 font-semibold text-gray-800">No Recent Post</h3>
                        <p className="mt-1 text-sm text-gray-500">You are yet to create a post</p>
                        <button
                            onClick={handleCreatePost}
                            className="mt-6 bg-forestGreen-100 hover:bg-green-700 text-white font-semibold py-2.5 px-5 rounded-lg transition-colors text-sm inline-flex items-center gap-2"
                        >
                           <PlusIcon /> Create New
                        </button>
                    </div>
                )}
            </div>
        </Card>

        <Card 
            title="Subscribers"
            headerAction={<button className="text-gray-500 hover:text-gray-800"><MoreIcon className="w-5 h-5" /></button>}
        >
            <div className="flex justify-between items-center">
                <p className="text-4xl font-bold text-gray-800">600</p>
                <div className="flex items-center gap-2 text-sm font-medium text-green-600 bg-green-50 rounded-full px-3 py-1.5">
                    <TrendUpIcon className="w-4 h-4"/>
                    100 over the last 30 days
                </div>
            </div>
        </Card>

    </div>
  );
};

const ContentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);


export default Dashboard;
